export default __webpack_public_path__ + "static/media/hht2_ep03_book_wp_02.a271dfb3.jpg";